/** « Mon compte » : qui l'on est, ce que le forfait donne, ce qu'on a accepté. */
export const ACCOUNT_PATH = "/account";
